import {useContext, useEffect, useRef} from "react";
import {gsap} from "gsap";
import ClickContext from "../context/ClickContext";

const Skills = () => {
  const {skillsClick, skillRef} = useContext(ClickContext);

  const skills = [
    {name: "Node.js", know: 75, color: "cyan", icon: "🟢"},
    {name: "React", know: 70, color: "yellow", icon: "⚛️"},
    {name: "Javascript", know: 80, color: "orange", icon: "☕📜"},
    {name: "Mongo DB", know: 80, color: "green", icon: "🍃"},
    {name: "MySql", know: 70, color: "cyan", icon: "🐬"},
  ];

  return (
    <section className="bg-x-gray-dark bg-vector-img text-white py-16">
      <div className="md:mx-24 mx-5">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6" ref={skillRef}>
          {skills.map((skill, i) => (
            <SkillCard key={i} skill={skill} index={i} skillsClick={skillsClick} />
          ))}
        </div>
      </div>
    </section>
  );
};

const SkillCard = ({skill, index, skillsClick}) => {
  const cardRef = useRef(null);
  const barRef = useRef(null);

  useEffect(() => {
    if (cardRef.current) {
      gsap.fromTo(cardRef.current, {y: 50, opacity: 0}, {y: 0, opacity: 1, duration: 0.6, delay: index * 0.1});
    }

    if (barRef.current) {
      gsap.fromTo(barRef.current, {width: "0%"}, {width: `${skill.know}%`, duration: 1.5, delay: index * 0.1 + 0.5});
    }
  }, [skill.know, index]);

  const handleMouseEnter = () => {
    gsap.to(cardRef.current, {scale: 1.05, duration: 0.3});
  };

  const handleMouseLeave = () => {
    gsap.to(cardRef.current, {scale: 1, duration: 0.3});
  };

  return (
    <div ref={cardRef} className={`bg-x-gray-dark-v2 rounded-lg p-6 cursor-pointer transition-all ${skillsClick ? "animate-pulse" : ""}`} style={{boxShadow: "3px 3px 0px 2px black"}} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div className="text-center mb-4">
        <div className="text-4xl mb-2">{skill.icon}</div>
        <h3 className="text-lg font-bold">{skill.name}</h3>
      </div>

      <div className="relative h-3 bg-x-gray-dark-v2 rounded-full overflow-hidden border border-gray-600">
        <div ref={barRef} className={`h-full bg-x-${skill.color} rounded-full transition-all duration-300`} />
      </div>
    </div>
  );
};

export default Skills;
